import { Avatar, Breadcrumb, Button, Image } from "antd";
import { AngleRight } from "../CustomIcons";

interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface HeaderProps {
  title: string;
  description?: string | React.ReactNode;
  btnText1?: string;
  btnIcon1?: JSX.Element;
  btnText2?: string;
  breadcrumb?: BreadcrumbItem[];
  imageIcon?: string;
  avatarColor?: string;
  avatarIcon?: React.ReactNode;
}

export default function Header({
  title,
  description,
  btnText1,
  btnIcon1,
  btnText2,
  breadcrumb = [],
  imageIcon,
  avatarIcon,
  avatarColor,
}: HeaderProps) {
  return (
    <div className="profileHeader">
      <div className="headerLeft">
        {breadcrumb.length > 0 && (
          <Breadcrumb
            separator={<AngleRight />}
            style={{ marginBottom: "12px" }}
          >
            {breadcrumb.map((item, index) => (
              <Breadcrumb.Item key={index}>
                {item.href ? <a href={item.href}>{item.label}</a> : item.label}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}
        {imageIcon || avatarIcon ? (
          <div className="headerContentWithImage">
            {imageIcon && <Image src={imageIcon} preview={false} />}
            {avatarIcon && (
              <Avatar
                size={58}
                className={avatarColor}
                shape="square"
                src={avatarIcon}
              />
            )}
            <div>
              <h2>{title}</h2>
              {description && <p>{description}</p>}
            </div>
          </div>
        ) : (
          <>
            <h2>{title}</h2>
            {description && <p>{description}</p>}
          </>
        )}
      </div>
      {(btnText1 || btnText2) && (
        <div className="two_btns">
          {btnText1 && (
            <Button htmlType="submit" size="large" className="btn-sm">
              {btnIcon1 && btnIcon1} {btnText1}
            </Button>
          )}
          {btnText2 && (
            <Button htmlType="submit" size="large" className="outlined-btn">
              {btnText2}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
